import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { SignupService } from './signup.service';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';

// Angular Material imports
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CanonicalService } from '../../shared/seo/canonical.service';
declare var $: any;

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatOptionModule],
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class SignupComponent implements OnInit, AfterViewInit {
  @ViewChild('countrySearchInput') countrySearchInput!: ElementRef;
  @ViewChild('stateSearchInput') stateSearchInput!: ElementRef;

  filteredStates: any[] = [];
  countrySearch: string = '';
  filteredCountries: any[] = [];
  allStates: any[] = [];
  currentStep = 1;
  signupUid = '';
  signupForm: FormGroup;
  signupFormStep2: FormGroup;
  submitted = false;
  submitted2 = false;

  isSubmittingStep1 = false;
isSubmittingStep2 = false;

  countries: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];

  ngAfterViewInit() {
    $('.selectpicker').selectpicker('refresh');
  }

  constructor(

    private fb: FormBuilder, private signupService: SignupService, private titleService: Title, private metaService: Meta,private route: ActivatedRoute,private canonicalService:CanonicalService) {
this.signupForm = this.fb.group(
  {
    fullName: [
      '',
      [
        Validators.required,
        Validators.pattern(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/)
      ]
    ],

    companyName: [
      '',
      [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(/^[a-zA-Z0-9][a-zA-Z0-9 &.,'-]*$/)
      ]
    ],

    phoneNumber: [
      '',
      [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]
    ],

businessEmail: [
  '',
  [
    Validators.required,
    Validators.pattern(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    )
  ]
],

    website: [
      '',
      [
        Validators.required,
        Validators.pattern(
          /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/
        )
      ]
    ],

    gst: [
      '',
      [
        Validators.pattern(/^[A-Za-z0-9-]+$/)
      ]
    ],

    country: [
      '',
      Validators.required
    ],

    state: [
      '',
      Validators.required
    ],

    city: [
      '',
      [
        Validators.required,
        Validators.pattern(/^[a-zA-Z]+(?:[ .'-][a-zA-Z]+)*$/)
      ]
    ],

    address: [
      '',
      [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(250)
      ]
    ],

    zip: [
      '',
      [
        Validators.required,
        Validators.pattern(/^[0-9]{6}$/)
      ]
    ],

    username: [
      '',
      [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern(/^[a-zA-Z0-9_]+$/)
      ]
    ],

    password: [
      '',
      [
        Validators.required,
        Validators.minLength(16),
        Validators.pattern(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{16,}$/
        )
      ]
    ],

    confirmPassword: [
      '',
      Validators.required
    ],
    utM_Source: [null],
utM_Medium: [null],
utM_Campaign: [null],
utM_Content: [null]
  },
  {
    validators: this.passwordMatchValidator
  }
);

    this.signupFormStep2 = this.fb.group({
      emailType: ['', Validators.required],
      sendMethod: ['', Validators.required],
      thirdPartyService: ['', Validators.required],
      primaryUseCase: ['', Validators.required],
      emailProvider: ['', Validators.required],
      volumeRequirement: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      bounceProcess: ['', Validators.required],
      optInLink: ['', Validators.required],
      permissions: ['', Validators.required],
      cleanList: ['', Validators.required],
      privacyPolicy: ['', Validators.required],
      antiSpam: ['', Validators.required],
      agree: [false, Validators.requiredTrue]
    });
  }



ngOnInit() {
  this.loadCountriesAndStates();


   this.titleService.setTitle(
    'Sign Up for MALtech Transactional Email Services'
  );

  this.metaService.updateTag({
    name: 'description',
    content:
      'Sign up for MALtech Transactional Email API to send reliable order confirmations, OTPs, alerts and other business emails with secure APIs, real-time analytics and scalable email delivery.'
  });

  this.metaService.updateTag({
    name: 'keywords',
    content:
      'MALtech transactional email, transactional email API, transactional email signup, email API, SMTP relay, Web API, SMTP API, OTP email API, business email API, transactional email service'
  });

  this.metaService.updateTag({
    name: 'robots',
    content: 'index, follow'
  });

    this.metaService.updateTag({ name: 'author', content: 'Maltech' });


  /* =====================================================
     CANONICAL
  ====================================================== */

  this.canonicalService.setCanonicalURL(
    'sign-up/'
  );
this.route.queryParams.subscribe(params => {
  const utmData = {
    utM_Source: params['utm_source'] || null,
    utM_Medium: params['utm_medium'] || null,
    utM_Campaign: params['utm_campaign'] || null,
    utM_Content: params['utm_content'] || null
  };

  this.signupForm.patchValue(utmData);

  console.log('UTM Parameters:', utmData);
});
}


loadCountriesAndStates() {
  forkJoin({
    countries: this.signupService.getCountries(),
    states: this.signupService.getStates()
  }).subscribe({
    next: ({ countries, states }) => {
      this.countries = (countries.result || []).map((c: any) => ({
        id: c.countryId,
        name: c.countryName,
        code: c.countryCode,
        minPhoneLength: c.minPhoneLength,
        maxPhoneLength: c.maxPhoneLength
      }));
      this.filteredCountries = [...this.countries];

      this.allStates = (states.result || []).map((s: any) => ({
        id: s.stateId,
        name: s.stateName,
        countryId: s.countryId
      }));
    },
    error: (err) => console.error('Failed to fetch countries/states', err)
  });
}



  // filterCountries() {
  //   const search = this.countrySearch.toLowerCase();
  //   this.filteredCountries = this.countries.filter(c =>
  //     c.name.toLowerCase().includes(search)
  //   );
  // }

  // // Select a country from the dropdown
  // selectCountry(country: any) {
  //   this.signupForm.patchValue({ country: country.id });
  //   this.countrySearch = country.name;
  //   this.filteredCountries = [];
  //   this.onCountryChange(); // load states for selected country
  // }
onCountryChange(event: any) {
  const selectedCountryId = event.value;
  if (!selectedCountryId) return;

  this.stateList = this.allStates.filter(s => s.countryId === selectedCountryId);
  this.filteredStates = [...this.stateList];
  this.signupForm.patchValue({ state: '', city: '' });
}

  onCountryDropdownOpened() {
    this.filteredCountries = [...this.countries];
  }

  filterCountries(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredCountries = this.countries.filter(c =>
      c.name.toLowerCase().includes(searchTerm)
    );
  }

  onStateDropdownOpened() {
    this.filteredStates = [...this.stateList];
  }

  filterStates(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredStates = this.stateList.filter(s =>
      s.name.toLowerCase().includes(searchTerm)
    );
  }




  passwordMatchValidator(group: AbstractControl) {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('confirmPassword')?.value;
    return pass === confirmPass ? null : { mismatch: true };
  }

  get f() { return this.signupForm.controls; }
  get f2() { return this.signupFormStep2.controls; }

  touchField(field: string) {
    this.signupFormStep2.get(field)?.markAsTouched();
  }

  // Step 1 submit
onSubmitStep1() {
  this.submitted = true;

  if (this.isSubmittingStep1) {
    return;
  }

  if (this.signupForm.invalid) {
    this.signupForm.markAllAsTouched();
    return;
  }

  this.isSubmittingStep1 = true;

  const formValue = this.signupForm.value;

  const selectedCountry = this.countries.find(
    c => c.id == formValue.country
  );

  const selectedState = this.stateList.find(
    s => s.id == formValue.state
  );

  if (!selectedCountry || !selectedState) {
    this.isSubmittingStep1 = false;

    Swal.fire(
      'Error',
      'Please select a valid country and state.',
      'error'
    );

    return;
  }

  const step1Data = {
  ...formValue,

  country: selectedCountry.name,
  state: selectedState.name,

  utM_Source: formValue.utM_Source || null,
  utM_Medium: formValue.utM_Medium || null,
  utM_Campaign: formValue.utM_Campaign || null,
  utM_Content: formValue.utM_Content || null
};

// Confirm password should not be sent
delete step1Data.confirmPassword;

console.log('Step 1 Payload:', step1Data);

  // confirmPassword should not be sent
  delete step1Data.confirmPassword;

  console.log('Step 1 Payload:', step1Data);

  this.signupService.signupStep1(step1Data).subscribe({
    next: (res) => {
      this.isSubmittingStep1 = false;

      console.log('Step 1 Response:', res);

      if (res.isSuccess) {
        this.signupUid = res.result;

        Swal.fire(
          'Success',
          'Step 1 completed!',
          'success'
        );

        this.currentStep = 2;
      } else {
        Swal.fire(
          'Error',
          res.error || 'Step 1 failed',
          'error'
        );
      }
    },

    error: (err) => {
      this.isSubmittingStep1 = false;

      console.error('Step 1 API Error:', err);
      console.error('Status:', err.status);
      console.error('Error Body:', err.error);

      Swal.fire(
        'Error',
        err?.error?.message ||
        err?.error?.error ||
        `Server error (${err.status || 'Unknown'}) in Step 1`,
        'error'
      );
    }
  });
}

  // Step 2 submit
onSubmitStep2() {
  this.submitted2 = true;

  // Prevent multiple clicks while API is running
  if (this.isSubmittingStep2) {
    return;
  }

  // Validate form
  if (this.signupFormStep2.invalid) {
    this.signupFormStep2.markAllAsTouched();
    return;
  }

  this.isSubmittingStep2 = true;

  const step2Data = {
    ...this.signupFormStep2.value,
    uid: this.signupUid
  };

  console.log('Step 2 Payload:', step2Data);

  this.signupService.signupStep2(step2Data).subscribe({
    next: (res) => {
      // Allow submit again
      this.isSubmittingStep2 = false;

      console.log('Step 2 Response:', res);

      if (res.isSuccess) {
        Swal.fire({
          title: 'Success',
          html: 'Successfully signed up! Support has activated your account.<br><a href="/contact" style="color: #009fe4; text-decoration: underline;">Click here to contact the support team</a>.',
          icon: 'success',
          showCloseButton: true,
          confirmButtonText: 'OK',
          confirmButtonColor: '#009fe4'
        }).then((result) => {
          if (result.isConfirmed) {
            this.signupForm.reset();
            this.signupFormStep2.reset();

            this.currentStep = 1;
            this.signupUid = '';

            window.location.reload();
          }
        });

      } else {
        Swal.fire(
          'Error',
          res.error || 'Step 2 failed',
          'error'
        );
      }
    },

    error: (err) => {
      // VERY IMPORTANT:
      // Reset this so user can click Submit again
      this.isSubmittingStep2 = false;

      console.error('Step 2 API Error:', err);
      console.error('Status:', err.status);
      console.error('Error Body:', err.error);

      Swal.fire(
        'Error',
        err?.error?.message ||
        err?.error?.error ||
        `Server error (${err.status || 'Unknown'}) in Step 2`,
        'error'
      );
    }
  });
}

  showPassword: boolean = false; // hidden by default
  showConfirmPassword: boolean = false; // hidden by default

  togglePassword(field: string) {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else if (field === 'confirmPassword') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  onFullNameInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  // Allow only alphabets and spaces
  input.value = input.value.replace(/[^a-zA-Z ]/g, '');

  // Update the form control value
  this.signupForm.get('fullName')?.setValue(input.value, {
    emitEvent: false
  });
}

onCompanyNameInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  // Allow only alphabets and spaces
  input.value = input.value
    .replace(/[^a-zA-Z ]/g, '')
    .replace(/\s{2,}/g, ' ');

  this.signupForm.get('companyName')?.setValue(input.value, {
    emitEvent: false
  });
}

onPhoneInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/\D/g, '')
    .slice(0, 10);

  this.signupForm.get('phoneNumber')?.setValue(input.value, {
    emitEvent: false
  });
}

onCityInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/[^a-zA-Z .'-]/g, '')
    .replace(/\s{2,}/g, ' ');

  this.signupForm.get('city')?.setValue(input.value, {
    emitEvent: false
  });
}


onZipInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/\D/g, '')
    .slice(0, 6);

  this.signupForm.get('zip')?.setValue(input.value, {
    emitEvent: false
  });
}


onUsernameInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/[^a-zA-Z0-9_]/g, '')
    .slice(0, 50);

  this.signupForm.get('username')?.setValue(input.value, {
    emitEvent: false
  });
}

onGstInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toUpperCase();

  this.signupForm.get('gst')?.setValue(input.value, {
    emitEvent: false
  });
}

onEmailInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/\s/g, '');

  this.signupForm.get('businessEmail')?.setValue(input.value, {
    emitEvent: false
  });
}

onPasswordInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  // Block HTML tag characters
  input.value = input.value.replace(/[<>]/g, '');

  this.signupForm.get('password')?.setValue(input.value, {
    emitEvent: false
  });
}

onConfirmPasswordInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/[<>]/g, '');

  this.signupForm.get('confirmPassword')?.setValue(input.value, {
    emitEvent: false
  });
}

onAddressInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/[<>]/g, '');

  this.signupForm.get('address')?.setValue(input.value, {
    emitEvent: false
  });
}

onVolumeRequirementInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/\D/g, '');

  this.signupForm.get('volumeRequirement')?.setValue(input.value, {
    emitEvent: false
  });
}

}